//menu hover
let items = document.querySelectorAll(".header__inline-menu details");
items.forEach((item) => {
  item.addEventListener("mouseover", () => {
    item.setAttribute("open", true);
    item.querySelector("ul").addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
});

// 3 Simple Steps section
initTimelineAnimation(".timeline-section .timeline-card");

// document.querySelectorAll('.country-option').forEach(option => {
//   option.addEventListener('click', function(e) {
//     e.preventDefault();
//     const selectedCountry = this.querySelector('.flag').outerHTML + ' ' + this.textContent.trim();
//     document.querySelector('.selected-country').innerHTML = selectedCountry;
//   });
// });

const SENTENCE_DELAY = 80;

// Function to initialize fading for a specific sentence
function initializeFading(sentenceElement) {
  sentenceElement.innerHTML = sentenceElement.textContent
    .split(" ")
    .map((word) => `<span class="faded-word">${word}</span>`)
    .join(" ");

  let wordsForFading = sentenceElement.querySelectorAll(".faded-word");

  wordsForFading.forEach((word) => {
    word.addEventListener("transitionend", (e) =>
      startNextWordAnimation(e, sentenceElement)
    );
  });

  startSentence(sentenceElement);
}

function startNextWordAnimation(e, sentenceElement) {
  let nextWord = e.target.nextElementSibling;
  if (nextWord) {
    nextWord.classList.add("faded-activated");
  } else {
    let nextSentence = sentenceElement.nextElementSibling;
    if (nextSentence && nextSentence.classList.contains("faded-sentence")) {
      startSentence(nextSentence);
    }
  }
}

function startSentence(sentenceElement) {
  if (!sentenceElement) {
    return;
  }
  setTimeout(() => {
    let firstWord = sentenceElement.querySelector(".faded-word");
    if (firstWord) {
      firstWord.classList.add("faded-activated");
    }
  }, SENTENCE_DELAY);
}

function isInViewport(el) {
  const rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

// Apply fading for all .faded-sentence elements
document.querySelectorAll(".faded-sentence").forEach((sentence) => {
  initializeFading(sentence);
});

// Apply fading for all .faded-sentence elements when scroll
window.addEventListener("scroll", () => {
  let fadedSentenceEle = document.querySelectorAll(".faded-sentence");
  if (fadedSentenceEle.length) {
    fadedSentenceEle.forEach((section) => {
      if (isInViewport(section)) {
        if (!section.classList.contains("anim-applied")) {
          initializeFading(section);
          section.classList.add("anim-applied");
        }
      }
    });
  }
});

// Restart functionality
if (document.querySelector("#restart")) {
  document.querySelector("#restart").addEventListener("click", (e) => {
    e.target.blur();
    document.querySelectorAll(".faded-word").forEach((word) => {
      word.classList.remove("faded-activated");
    });
    document.querySelectorAll(".faded-sentence").forEach((sentence) => {
      initializeFading(sentence);
    });
  });
}

//submenu
document.querySelectorAll("details").forEach((details) => {
  details.addEventListener("toggle", function () {
    if (this.open) {
      const submenu = this.querySelector("ul");
      submenu.style.height = "0px";
      submenu.style.overflow = "hidden";
      submenu.style.transition = "height 0.5s ease-in-out";

      // Get actual height of submenu
      const submenuHeight = submenu.scrollHeight;

      // Allow submenu to grow smoothly
      setTimeout(() => {
        submenu.style.height = `${submenuHeight}px`;
      }, 10);

      submenu.addEventListener(
        "transitionend",
        function () {
          submenu.style.height = "auto"; // After animation ends, remove height restriction
          submenu.style.overflow = "visible"; // Ensure submenu scrolls if necessary
        },
        { once: true }
      );
    } else {
      const submenu = this.querySelector("ul");
      submenu.style.height = `${submenu.scrollHeight}px`;

      // Trigger collapsing animation
      setTimeout(() => {
        submenu.style.height = "0px";
      }, 10);
    }
  });
});

$(".us-pop").click(function () {
  $("body").addClass("overlay no-scroll");
  $(".close-pop").show();
  hbspt.forms.create({
    region: "na1",
    portalId: "3921157",
    formId: "1aa9b30f-779e-4187-92d3-2d77c3272cc8",
  });
});

$(".close-pop").click(function () {
  $("body").removeClass("overlay no-scroll");
  // $(this).css('display', 'none');
  $(".hbspt-form").hide();
});

$(".uk-pop").click(function () {
  $("body").addClass("overlay no-scroll");
  $(".close-pop").show();
  hbspt.forms.create({
    region: "na1",
    portalId: "3921157",
    formId: "1aa9b30f-779e-4187-92d3-2d77c3272cc8",
  });
});

$(document).ready(function () {
  // Trigger change event for the initially checked radio button on page load
  var selectedRadio = $('.main-variant input[type="radio"]:checked');
  if (selectedRadio.length) {
    var newWords = selectedRadio.data("words");
    var newBookPhoto = selectedRadio.data("bookphoto");

    // Update hidden input fields with the initial data
    $('input[name="properties[Words]"]').val(newWords);
    $('input[name="properties[Interview Hours]"]').val(newBookPhoto);

    console.log("Initial updated data-words:", newWords);
    console.log("Initial updated data-bookphoto:", newBookPhoto);
  }

  // Handle changes on radio button selection
  $('.main-variant input[type="radio"]').on("change", function () {
    var selectedRadio = $(this);

    var newWords = selectedRadio.data("words");
    var newBookPhoto = selectedRadio.data("bookphoto");

    // Update hidden input fields with the new data
    $('input[name="properties[Words]"]').val(newWords);
    $('input[name="properties[Interview Hours]"]').val(newBookPhoto);
    // setTimeout(function(){
    //   console.log($('[data-type="one-time"] .mask_bundle_price'),'innnnnnnppppoooopppp',$(this).attr('data-price'));
    //   var get_price = $(this).attr('data-price');
    //   $('[data-type="one-time"] .mask_bundle_price').val(get_price);
  
    //   var get_price_sub = $(this).attr('data-sub-price');
    //   $('[data-type="subscription"] .mask_bundle_price').val(get_price_sub);
    // },1000)
    console.log("Updated data-words:", newWords);
    console.log("Updated data-bookphoto:", newBookPhoto);
  });
});

// document.querySelector('.get-quote').addEventListener('click', function() {
//    // Get the product variant ID from the hidden input
//    var variantId = document.querySelector('.product-variant-id').value;

//    // Get the custom properties
//    var properties = {
//      '1': document.querySelector('input[name="properties[1]"]').value,
//      '2': document.querySelector('input[name="properties[2]"]').value,
//      '3': document.querySelector('input[name="properties[3]"]').value,
//      '4': document.querySelector('input[name="properties[4]"]').value,
//      '5': document.querySelector('input[name="properties[5]"]').value,
//      '6': document.querySelector('input[name="properties[6]"]').value
//    };

//    // Add the product to the cart with the custom properties
//    fetch('/cart/add.js', {
//      method: 'POST',
//      headers: {
//        'Content-Type': 'application/json'
//      },
//      body: JSON.stringify({
//        items: [{
//          id: variantId,
//          quantity: 1,
//          properties: properties
//        }]
//      })
//    })
//    .then(response => response.json())
//    .then(data => {
//      // Redirect to checkout after adding to cart
//      window.location.href = '/checkout';
//    })
//    .catch(error => {
//      console.error('Error adding to cart:', error);
//    });
//  });

function initTimelineAnimation(selector) {
  try {
    const cards = document.querySelectorAll(selector);

    // Error handling: Check if cards exist
    if (!cards || cards.length === 0) {
      console.warn(`No elements found for the selector: ${selector}`);
      return;
    }

    // IntersectionObserver callback function
    const observerCallback = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Add a class when the card enters the viewport at 50vh
          entry.target.classList.add("visible");
        } else if (entry.boundingClientRect.top > window.innerHeight * 0.5) {
          // Remove the class if the card scrolls above the 50vh threshold
          entry.target.classList.remove("visible");
        }
      });
    };

    // IntersectionObserver options
    const observerOptions = {
      root: null,
      rootMargin: "0px 0px -50% 0px",
      threshold: 0,
    };

    // Create an IntersectionObserver
    const observer = new IntersectionObserver(
      observerCallback,
      observerOptions
    );

    // Observe each card
    cards.forEach((card) => {
      if (card instanceof HTMLElement) {
        observer.observe(card);
      } else {
        console.error("Invalid card element detected:", card);
      }
    });

    console.log(`Timeline animation initialized for ${cards.length} elements.`);
  } catch (error) {
    console.error(
      "An error occurred while initializing the timeline animation:",
      error
    );
  }
}

if (document.body.classList.contains('template-product')) {
  setTimeout(() => {
    const videoBtn = document.querySelector('.video_btn');
    if (videoBtn) {
      videoBtn.click();
    }
  }, 500);
}
